import { RequestType } from 'features/notifications/types';

import { toI18n } from 'util/i18n';

export const title: Record<RequestType, string> = {
  availability: toI18n('requests_feed.base_request.title.availability'),
  time_off: toI18n('requests_feed.base_request.title.time_off'),
  claim: toI18n('requests_feed.base_request.title.claim'),
  cover: toI18n('requests_feed.base_request.title.cover'),
  trade: toI18n('requests_feed.base_request.title.trade'),
};
